<div class="d-inline-block">
  <!-- Badge visible sur tous les écrans si pas d'émoji, sinon seulement sm et + -->
  <mdb-badge
    *ngIf="options.labelKey || options.label"
    [ngClass]="{
      'd-none d-sm-block': options.emoji,
      'd-block': !options.emoji
    }"
    class="p-2 my-1"
    [pill]="pill"
    [success]="options.color === colorEnum.SUCCESS"
    [info]="options.color === colorEnum.INFO"
    [danger]="options.color === colorEnum.DANGER"
    [warning]="options.color === colorEnum.WARNING"
    [primary]="options.color === colorEnum.PRIMARY"
  >
    <span *ngIf="options.labelKey" [mdbTooltip]="options.tooltipKey! | translate"> {{ options.label }} {{ options.labelKey | translate }} </span>
    <span *ngIf="options.label && !options.labelKey" [mdbTooltip]="options.tooltipKey! | translate">
      {{ options.label }}
    </span>
    <jhi-bary-icon
      *ngIf="options.icon"
      [icon]="options.icon"
      [faDirective]="FAS"
      [title]="options.iconTooltipKey! | translate: options.iconTooltipParams"
      class="pl-1"
    ></jhi-bary-icon>
  </mdb-badge>

  <span *ngIf="options.emoji" [class.d-sm-none]="options.labelKey || options.label" class="d-block emojis" [mdbTooltip]="options.labelKey! | translate">
    {{ options.emoji }}
  </span>
</div>
